module.exports = __webpack_public_path__ + "static/step-3.612c8f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/fetching/step-3.png
// module id = 2561
// module chunks = 44794810369691